import type { ReactNode } from 'react';

/** Navigation page précédente/suivante, avec le compte total — RG non numérotée. */
export function Pagination({
  page,
  limite,
  total,
  onPage,
}: {
  page: number;
  limite: number;
  total: number;
  onPage: (page: number) => void;
}): ReactNode {
  if (total <= limite && page === 1) return null;

  const premiere = total === 0 ? 0 : (page - 1) * limite + 1;
  const derniere = Math.min(total, page * limite);
  const dernierePage = Math.max(1, Math.ceil(total / limite));

  return (
    <div className="ligne" style={{ justifyContent: 'space-between', marginTop: 12 }}>
      <span className="entete__sous">
        {premiere}–{derniere} sur {total}
      </span>
      <div className="ligne">
        <button
          type="button"
          className="bouton--discret"
          disabled={page <= 1}
          onClick={() => {
            onPage(page - 1);
          }}
        >
          Précédent
        </button>
        <span className="entete__sous">
          Page {page} / {dernierePage}
        </span>
        <button
          type="button"
          className="bouton--discret"
          disabled={page >= dernierePage}
          onClick={() => {
            onPage(page + 1);
          }}
        >
          Suivant
        </button>
      </div>
    </div>
  );
}
